export class AnchorScroll {
	constructor() {
		this.anchors = document.querySelectorAll(
			'a[href^="#"]:not([href="#"])'
		);
	}

	init() {
		if (this.anchors) {
			this.anchors.forEach((anchor) => {
				anchor.addEventListener('click', (event) => {
					event.preventDefault();

					this.onAnchorClick(event);
				});
			});
		}
	}

	onAnchorClick(event) {
		const idTarget = event.target.getAttribute('href').split('#')[1];
		const target = document.getElementById(idTarget);

		if (target) {
			this.scrollToSection(target);
		}
	}

	scrollToSection(target) {
		target.scrollIntoView({
			behavior: 'smooth',
		});
	}

}

$(document).ready(function(){


  $(window).load(function(){
    // Remove the # from the hash, as different browsers may or may not include it
    var hash = location.hash.replace('#','');

    if(hash != ''){
    	//alert('hash');
       // Clear the hash in the URL
       // location.hash = '';   // delete front "//" if you want to change the address bar
        $('html, body').animate({ scrollTop: $('#'+hash).offset().top}, 500);

       }
   });
});
